
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PricingContent from '@/components/pricing/PricingContent';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import { updateMetaTags, getCanonicalUrl } from '@/utils/seoUtils';

const PricingPage = () => {
  const { currentLanguage } = useLanguage();
  const { lang } = useParams<{ lang: string }>();
  const t = translations[currentLanguage];
  
  useEffect(() => {
    // Update SEO meta tags
    updateMetaTags({
      title: `${t.pricing} | Future Level`,
      description: t.pricingDescription || 'Transparente Preise für KI-Videoproduktion: Premium Pakete und individuelle Lösungen für Ihr Unternehmen.',
      keywords: "KI Video Preise, Videomarketing Kosten, KI Videoproduktion Preise, Social Media Video Pakete, Produktvideo Preise",
      canonicalUrl: getCanonicalUrl(currentLanguage === 'de' ? 'preise' : 
                                   currentLanguage === 'en' ? 'pricing' : 
                                   currentLanguage === 'fr' ? 'tarifs' : 'prezzi', 
                                   currentLanguage),
      language: currentLanguage,
      ogType: "website"
    });
  }, [currentLanguage, t]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <div className="py-16 bg-gradient-to-b from-[#0B0B0B] to-[#101010]">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 font-future text-white micro-glitch">{t.pricing}</h1>
              <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                {t.pricingSubtitle}
              </p>
              <div className="w-3 h-3 rounded-full bg-purple-500 mx-auto mt-6 animate-pulse"></div>
            </div>
          </div>
        </div>
        
        <PricingContent />
      </main>
      <Footer />
    </div>
  );
};

export default PricingPage;
